import { api } from '@/core/api';

const URL = '/api/providers/proposal';
const baseApiReport = '/api/report';

export const getInitFilters = () => api.get(`${URL}/initfilters`);

export const getInitFiltersEvaluators = () =>
  api.get(`${URL}/evaluator/initfilters`);

export const getAdminFilters = async (academicYear) => {
  let responseObject = {};
  await api
    .get(`${URL}/academicyears`)
    .then((response) => {
      responseObject.AcademicYear = response.data;
      return api.get(`${URL}/area`);
    })
    .then((response) => {
      responseObject.Area = response.data;
      if (academicYear) {
        return api.get(`${URL}/evaluators/${academicYear}`);
      }
    })
    .then((response) => {
      responseObject.Evaluators = response.data;
      return api.get(`${URL}/companies`);
    })
    .then((response) => {
      responseObject.Companies = response.data;
      return api.get(`${URL}/statuses`);
    })
    .then((response) => {
      responseObject.Statuses = response.data;
    })
    .catch(({ errors }) => {
      return errors;
    });

  return responseObject;
};

export const getProposalService = (params) =>
  api.get(`${URL}/proposalrequests`, { params });

export const getAcademicYears = () => api.get(`${URL}/academicyears`);

export const previewProposalsAssignedToEvaluators = () =>
  api.get(`${URL}/evaluator/assign/preview`);

export const proposalsCanBeAssignedToEvaluators = () =>
  api.get(`${URL}/evaluator/canbeassigned`);

export const getEvaluatorsByYearId = (academicYearId = '') =>
  api.get(`${URL}/evaluators/${academicYearId}`);

export const getCompaniesByYearId = (academicYearId = '') =>
  api.get(`${URL}/companies/${academicYearId}`);

export const validateProposalsAssignedToEvaluators = () =>
  api.get(`${URL}/evaluator/assign/validate`);

export const getpreviewProposalsAssignedToEvaluators = () =>
  api.get(`${URL}/evaluator/assign/preview`);

export const assignProposalsToEvaluators = () =>
  api.post(`${URL}/evaluator/assign`);

export const assignEvaluatorToProposalsByAnnouncement = (announcementId) =>
  api.post(`${URL}/evaluator/assign/${announcementId}`);

export const removeEvaluatorUserProposal = (parameters) =>
  api.post(`${URL}/removeevaluatoruserproposal`, parameters);

export const cancelProposalEvaluation = (evaluatorUserProposalId) =>
  api.post(
    `${URL}/cancelProposalEvaluation`,
    {
      evaluatorUserProposalId,
    },
    {
      params: {
        evaluatorUserProposalId,
      },
    }
  );

export const getUnselectedEvaluators = (params) =>
  api.get(`${URL}/evaluator/search`, { params });

export const getAllEvaluatorUsers = (params) =>
  api.get(`${URL}/evaluators`, { params });

export const getSelectedEvaluators = (params) =>
  api.get(`${URL}/evaluator/selected`, { params });

export const addEvaluatorUser = (params) =>
  api.post(`${URL}/evaluator`, params);

export const editEvaluatorUser = (params) =>
  api.put(`${URL}/evaluator`, params);

export const removeEvaluatorUser = (params) =>
  api.delete(`${URL}/evaluator/${params.academicYearId}/${params.userId}`);

export const getProposalRequest = (proposalRequestId) =>
  api.get(`${URL}/providerproposal/${proposalRequestId}`);

export const getProposalRequestEvalutions = (proposalRequestId) =>
  api.get(`${URL}/evaluator/evaluations/${proposalRequestId}`);

export const getEvaluationCenters = (payload) =>
  api.get(`${URL}/evaluationcenters`, payload);

export const sendEvaluationRequest = (
  proposalRequestId,
  proposalSupervisorCenterId
) =>
  api.post(`${URL}/sendevaluationrequest`, {
    proposalRequestId,
    proposalSupervisorCenterId,
  });

export const getAvailableEvaluatorUser = (proposalRequestId) =>
  api.get(`${URL}/getavailableevaluatoruser/`, {
    params: {
      ...proposalRequestId,
    },
  });

export const addEvaluatorUserProposal = (parameters) =>
  api.post(`${URL}/addevaluatoruserproposal`, parameters);

export const evaluatorVerifyCode = (proposalRequestId, token) =>
  api.put(`${URL}/verifyCode/${proposalRequestId}/${token}`, {
    proposalRequestId,
    token,
  });

export const evaluatorConflictCert = (proposalRequestId) =>
  api.put(`${URL}/certAbsenceconflictInterest/${proposalRequestId}`, {
    proposalRequestId,
  });

export const getProposalRequestQuestionnaire = (
  proposalRequestId,
  proposalServiceTypeEvaluatorId,
  userId,
  rubricId
) =>
  api.get(`${URL}/questionnaire/`, {
    params: {
      proposalRequestId,
      proposalServiceTypeEvaluatorId,
      userId: userId,
      rubricId,
    },
  });

export const getProposalServiceTypeEvaluator = (proposalRequestId) =>
  api.get(`${URL}/typeevaluator/`, { params: { proposalRequestId } });

export const getTrackingHistoryByProposalRequestId = (
  proposalRequestId,
  params = {
    pageIndex: 1,
    pageSize: 10,
  }
) =>
  api.get(`${URL}/trackingHistory/`, {
    params: { proposalRequestId, ...params },
  });

export const getProposalProponentProfile = (proposalRequestId) =>
  api.get(`${URL}/profile/`, { params: { proposalRequestId } });

export const saveEvaluatorEvaluations = (form) =>
  api.post(`${URL}/evaluator/evaluations/save`, form);

export const getProposalEvaluationDocuments = (proposalRequestId, params) =>
  api.get(`${URL}/evaluation/documents/${proposalRequestId}`, { params });

export const getProposalDocuments = (proposalRequestId, params) =>
  api.get(`${URL}/${proposalRequestId}/documents`, { params });

export const evaluationFormPDF = (parameters) =>
  api.get(`${baseApiReport}/proposal/evaluationform`, {
    params: { ...parameters },
  });

export const getProposalRequesReport = (id) =>
  api.get(`${baseApiReport}/proposalrequest/${id}`);

export const getFiltersForSeparationFunds = (params) =>
  api.get(`${URL}/filtersforseparationfunds`, { params });

export const saveSeparationFund = (body) =>
  api.post(`${URL}/saveseparationfunds`, body);

export const editSeparationFund = (body) =>
  api.post(`${URL}/editseparationfunds`, body);

export const getSeparationFunds = (params) =>
  api.get(`${URL}/separationfunds`, { params });

export const denyContractDocument = (parameters) =>
  api.post(
    `${URL}/contractdocument/deny`,
    { parameters },
    { params: { ...parameters } }
  );

export const getContractDocumentHistory = (proposalRequestId, documentTypeid) =>
  api.get(
    `${URL}/getcontractdocumenthistory/${proposalRequestId}/${documentTypeid}`
  );

export const requestReplacementDocument = (parameters) =>
  api.post(
    `${URL}/contractdocument/requestreplacement`,
    { parameters },
    { params: { ...parameters } }
  );

export const approveContractDocument = (parameters) =>
  api.post(
    `${URL}/contractdocument/approve`,
    { parameters },
    { params: { ...parameters } }
  );

export const uploadContractDocument = (params) =>
  api.post(`${URL}/contractdocument/upload`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const submitProposalContractDocument = (proposalRequestId) =>
  api.post(
    `${URL}/submitContractDocument`,
    { proposalRequestId },
    { params: { proposalRequestId } }
  );

export const changeProposalStatus = (
  proposalRequestId,
  proposalStatusId,
  payload = {}
) =>
  api.post(`${URL}/changestatus`, {
    proposalRequestId,
    proposalStatusId,
    ...payload,
  });

export const submitProposalEvaluation = (
  proposalRequestId,
  isEducativeRelational = false
) =>
  api.post(
    `${URL}/submmitProposalEvaluation`,
    {
      proposalRequestId,
      isEducativeRelational,
    },
    {
      params: {
        proposalRequestId,
        isEducativeRelational,
      },
    }
  );

export const isAllContractDocumentSubmit = (proposalRequestId) =>
  api.get(`${URL}/isAllContractDocumentSubmit/${proposalRequestId}`);

export const getEvaluationProcess = () =>
  api.get(`${URL}/getevaluationprocess`);

export const OGPApprovalApplicationProposal = (parameters) =>
  api.post(
    `${URL}/aplicationapproachOGP`,
    {
      ...parameters,
    },
    {
      params: {
        ...parameters,
      },
    }
  );

export const GetCountDocumentContract = (proposalRequestId) =>
  api.get(`${URL}/contractdocument/verify/${proposalRequestId}`);

export const registractionContractOC = (parameters) =>
  api.post(
    `${URL}/contractregistration`,
    {
      ...parameters,
    },
    {
      params: {
        ...parameters,
      },
    }
  );

export const getContractDocument = (params) =>
  api.get(`${baseApiReport}/proposal/contractdocument`, { params });

export const getSummaryEvaluationProcessReport = (params) =>
  api.get(`${baseApiReport}/proposal/summaryevaluationprocess`, { params });

export const getEvaluatorProgressReport = (params) =>
  api.get(`${baseApiReport}/proposal/evaluatorprogress`, { params });

export const getSeparationFundsReport = (params) =>
  api.get(`${baseApiReport}/proposal/separationfunds`, { params });

export const getCertifiedAvailabilitySFReport = (params) =>
  api.get(`${baseApiReport}/proposal/certifiedavailabilityseparationfunds`, {
    params,
  });

export const getCertificationSFReport = (params) =>
  api.get(`${baseApiReport}/proposal/certificationseparationfunds`, { params });

export const submitProposalAmendmentDocument = (parameters) =>
  api.post(`${URL}/amendment`, parameters, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getAmendmentDocument = (proposalRequestId) =>
  api.get(`${URL}/amendment/${proposalRequestId}`);

export const getTokenRequestFilters = (academicYearId) =>
  api.get(`${URL}/tokenrequest/initfilters`, {
    params: {
      academicYearId,
    },
  });

export const getTokenRequestSearch = (params) =>
  api.get(`${URL}/tokenrequest`, { params });

export const getProposalDocumentBulk = (id) =>
  api.get(`${URL}/${id}/bulkdownload`);

export const getContractDocumentBulk = (id) =>
  api.get(`${URL}/${id}/contractbulkdownload`);

export const getMeasureBankByUser = (typeId) =>
  api.get(`${URL}/measurebankbyuser/${typeId}`);

export const saveMeasureBankForUser = (params) =>
  api.post(`${URL}/savemeasurebankforuser`, params);

export const updateMeasureBankForUser = (params) =>
  api.put(`${URL}/updatemeasurebankforuser`, params);

export const deleteMeasureBankForUser = (id) =>
  api.delete(`${URL}/deletemeasurebankforuser/${id}`);

export const getRubricsEducationalServicesReport = () =>
  api.get(`${baseApiReport}/proposal/rubricseducationalservices`);

export const getRubricsRelatedServicesReport = () =>
  api.get(`${baseApiReport}/proposal/rubricsrelatedservices`);

export const validatehasproposalrequest = (params) =>
  api.get(`${URL}/validatehasproposalrequest`, { params });

export const getRubricReport = (id) =>
  api.get(`${baseApiReport}/proposal/rubric/${id}`);

export const getProposalStatusTransition = (currentStatusId) =>
  api.get(`${URL}/proposalstatustransition/${currentStatusId}`);

export const getServiceTypesByArea = (areaId) =>
  api.get(`${URL}/${areaId}/servicetypes`);
